import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { withSnackbar } from 'notistack';
import LoadBox from '../../components/LazyBox';
import moment from 'moment';
import { Link } from 'react-router-dom';

import './cinema.css';

//services
import CinemaAPI from '../../../services/api/Cinema'

class Cinema extends React.Component {
	state = {
		filmes: [],

		loading: true,
	}

	refreshFilmes = () => {
		const { id } = this.props.match.params;
		CinemaAPI.lista_full(id)
			.then(res => {
				res.json().then(res => {
					if (res.msg) {
						return;
					}
					this.setState({
						filmes: res,
						loading: false,
					})
					return;
				})
			});
	}

	componentDidMount() {
		this.refreshFilmes()
	}

	render() {
		const { filmes, loading } = this.state;
		return (
			<div className="app_content_page" >
				<Helmet>
					<title>Cinema</title>
					<meta name="description" content="Helmet application" />
				</Helmet>
				<div className="app_content_page__title_body" >
					<div className="title_body__content" >
						<Typography variant="h5" >Cinema</Typography>
					</div>
				</div>
				<div className="app_content_cinema" >
					<LoadBox loading={loading} height="50vh">
						<Grid container spacing={16} className="grid_filmes" >
							{filmes.map((f, k) => <Grid key={k} className="row_cinema" component={Link} to={`cinema/filme/${f.IDFILME}`} item xs={12} md={12} >
								<Grid container spacing={16} className="container_filme" >
									<Grid item xs={12} md={2} >
										<img src={f.IMAGENS[0].URL} width="100%" alt={f.TITULO} />
									</Grid>
									<Grid item md={10} xs={12} >
										<Typography variant="subtitle2" gutterBottom>{f.ESTILO} {f.DURACAO ? `| ${f.DURACAO}min` : ''}</Typography>
										<Typography variant="h6" gutterBottom>{f.TITULO}</Typography>
										<Typography variant="body1" gutterBottom>{f.SINOPSE}</Typography>
										<Typography variant="subtitle2" style={{marginTop:30, marginBottom:20}}>PRÓXIMAS SESSÕES:</Typography>
										<Typography variant="body2" >
											{f.PROGRAMACAO[0] && <span className="time_sessao" >{moment(f.PROGRAMACAO[0].DATASESSAO).format('HH:mm')} </span>}
											{f.PROGRAMACAO[1] && <span className="time_sessao" >{moment(f.PROGRAMACAO[1].DATASESSAO).format('HH:mm')} </span>}
											{f.PROGRAMACAO[2] && <span className="time_sessao" >{moment(f.PROGRAMACAO[2].DATASESSAO).format('HH:mm')} </span>}
										</Typography>
									</Grid>
								</Grid>
							</Grid>)}
						</Grid>
					</LoadBox>
				</div>
			</div>
		);
	}
}

export default withSnackbar(Cinema);



// WEBPACK FOOTER //
// ./src/web/pages/cinema/index.js